import route from "ziggy-js";
import { Globe, Settings, Shield } from "lucide-vue-next";
import type TabItem from "@/types/Settings/TabItem";

type TranslateFn = (key: string) => string;

export const buildDomainReportTabs = (
    domain: string,
    t: TranslateFn,
): TabItem[] => [
    {
        title: t("vue.reports"),
        key: "domain-reports",
        icon: Globe,
        url: route("reports.show", { domain }),
    },
    {
        title: t("vue.dmarc_management"),
        key: "domain-dmarc-management",
        icon: Shield,
        url: route("reports.dmarc-management.show", { domain }),
    },
    {
        title: t("vue.settings"),
        key: "domain-settings",
        icon: Settings,
        url: route("reports.settings.show", { domain }),
    },
];
